import React, { useEffect, useState } from "react";
import DeleteModel from "../Components/DeleteModel";
import {
 deleteItem,
 fetchData,
 handleDragEnd,
 toggleStatus,
} from "../utils/apiUtils";
import {
 ActionButton,
 checkImage,
 PlusButton,
 ToggleSwitch,
} from "../helper/ImageFormat";
import CustomPagination from "../helper/Pagination";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Breadcrumb from "../helper/Breadcrumb";
import Spinner from "../Components/spinner";
import dateformate from "../helper/DateFormate";
import { useNavigate } from "react-router-dom";
const Testimonial = () => {
 const navigator = useNavigate();
 const [loading, setLoading] = useState(false);
 const [testimonialsData, settestimonialsData] = useState([]);
 const [deleteItemId, setDeleteItemId] = useState({});
 const [totalCount, setTotalCount] = useState(0);
 const [currentPage, setCurrentPage] = useState(1);
 const [perPage, setPerPage] = useState(10);
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const [isDeleting, setIsDeleting] = useState(false);
 const [nextPosition, setNextPosition] = useState(0);
 useEffect(() => {
  fetchTestimonial();
 }, []);

 const totalPages = Math.ceil(totalCount / perPage);

 const fetchTestimonial = async (page = 1) => {
  setLoading(true);
  const requestData = {
   perPage: perPage,
   pageNo: page,
  };
  await fetchData(
   "testimonial-pagination",
   requestData,
   settestimonialsData,
   setTotalCount,
   setCurrentPage,
   setLoading,
   setNextPosition
  );
 };

 const handlePageClick = (page) => {
  if (page >= 1 && page <= totalPages) {
   fetchTestimonial(page);
  }
 };

 const handleDelete = async (id) => {
  setDeleteItemId(id);
  setDeleteModalOpen(true);
 };

 const confirmDelete = async () => {
  setIsDeleting(true);
  try {
   const res = await deleteItem(
    "testimonial",
    deleteItemId?.id,
    fetchTestimonial,
    [deleteItemId?.image]
   );
   setDeleteItemId({});
   setDeleteModalOpen(false);
   return res;
  } catch (err) {
   throw err;
  } finally {
   setIsDeleting(false);
  }
 };

 const handleStatusToggle = async (previousdata) => {
  const data = await toggleStatus(
   "testimonial-status",
   previousdata?.id,
   previousdata?.isActive,
   fetchTestimonial
  );
  if (Object.keys(data).length > 0) {
   settestimonialsData((item) =>
    item.map((curr) =>
     curr.id === previousdata.id ? { ...curr, isActive: data?.isActive } : curr
    )
   );
  }
 };

 const handleOnDragEnd = (result) => {
  handleDragEnd({
   result,
   data: testimonialsData,
   setData: settestimonialsData,
   apiEndpoint: "/testimonial-position",
  });
 };

 const handleAdd = () => {
  navigator("/add-testimonials", { state: { nextPosition } });
 };

 const handleEditClick = (item) => {
  navigator("/add-testimonials", {
   state: item,
  });
 };

 const Tableheader = [
  "Date",
  "Testimonial By",
  "Image",
  "Updated At",
  "Is Active",
  "Action",
 ];
 const breadcrumbdata = [
  { label: "Home", path: "/" },
  { label: "Testimonals", path: "#" },
 ];
 return (
  <>
   <div className="content-wrapper">
    <div
     className="page-header mt-5"
     style={{ display: "flex", justifyContent: "space-between" }}
    >
     <h3 className="custom-page-title">Testimonials</h3>
     <Breadcrumb items={breadcrumbdata} />
    </div>
    <div
     className="d-flex justify-content-between mb-2"
     style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
    >
     <select
      className="form-control form-control-sm w-auto"
      value={perPage}
      onChange={(e) => setPerPage(Number(e.target.value))}
     >
      {[5, 10, 20, 50, 100, 150].map((limit) => (
       <option key={limit} value={limit}>
        {limit}
       </option>
      ))}
     </select>

     <PlusButton handleAdd={handleAdd} module={"Testimonials"} />
    </div>

    <div className="row">
     <div className="col-md-12 grid-margin stretch-card">
      <div className="card">
       <div className="card-body">
        <DragDropContext onDragEnd={handleOnDragEnd}>
         <Droppable droppableId="sliders">
          {(provided) => (
           <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className="table-responsive"
           >
            <table
             className=" custom-table table table-striped"
             id="testimonialtable"
            >
             <thead>
              <tr>
               <th className="font-weight-bold ">Sort Order</th>
               {Tableheader.map((item, index) => (
                <th className="font-weight-bold " key={index}>
                 {item}
                </th>
               ))}
              </tr>
             </thead>
             <tbody>
              {loading ? (
               <tr>
                <td colSpan="12" className="text-center">
                 <Spinner />
                </td>
               </tr>
              ) : (
               testimonialsData.map((item, index) => {
                return (
                 <Draggable
                  key={item.id}
                  draggableId={item.id.toString()}
                  index={index}
                 >
                  {(provided) => (
                   <tr
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                   >
                    <td>{item.position}</td>
                    <td>{dateformate(item?.review_date)}</td>
                    <td>{item?.customer_name}</td>
                    <td> {checkImage(item?.image)} </td>
                    <td>{dateformate(item?.updatedAt)}</td>

                    <td>
                     <ToggleSwitch
                      data={item}
                      name="isActive"
                      checked={item.isActive}
                      handleStatusToggle={handleStatusToggle}
                     />
                    </td>
                    <td className="text-center">
                     <ActionButton
                      data={item}
                      handleEditClick={handleEditClick}
                      handleDelete={handleDelete}
                      module={"Testimonials"}
                     />
                    </td>
                   </tr>
                  )}
                 </Draggable>
                );
               })
              )}
              {provided.placeholder}
             </tbody>
            </table>
           </div>
          )}
         </Droppable>
        </DragDropContext>
        {testimonialsData?.length > 0 && (
         <div>
          <CustomPagination
           currentPage={currentPage}
           totalPages={totalPages}
           onPageChange={handlePageClick}
           perPage={perPage}
           totalCount={totalCount}
          />
         </div>
        )}
       </div>
      </div>
     </div>
    </div>
   </div>

   {deleteModalOpen && (
    <DeleteModel
     deleteModalOpen={deleteModalOpen}
     setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
     onConfirm={confirmDelete}
     itemName="testimonial"
     isDeleting={isDeleting}
    />
   )}
  </>
 );
};

export default Testimonial;
